export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '2025年哪个看片网站最好用？',
    answer: '没有绝对"最好"的平台，取决于你的需求。追求内容全面可以选择爱奇艺或腾讯视频；喜欢综艺推荐芒果TV；注重性价比选B站大会员；想看海外内容首选Netflix。建议参考我们的详细测评文章，根据个人偏好选择。',
  },
  {
    id: 'faq-2',
    question: '免费看片网站安全吗？',
    answer: '正版免费平台（如央视网、1905电影网）是安全的。但请注意，网络上存在大量盗版和钓鱼网站，这些网站可能含有恶意软件、广告病毒，甚至窃取个人信息。我们强烈建议只使用正版平台观看影视内容。',
  },
  {
    id: 'faq-3',
    question: '如何选择适合自己的视频平台会员？',
    answer: '首先明确自己的观影偏好（剧集/综艺/电影/动漫/纪录片），然后查看各平台在该领域的独家内容。其次考虑预算和画质需求。如果你是淘宝88VIP用户，优酷会员几乎是免费的。最后可以先用免费试用期体验，再做决定。',
  },
  {
    id: 'faq-4',
    question: '看片网站的VPN怎么选？',
    answer: '选择VPN时关注以下几点：隐私政策（是否记录日志）、服务器覆盖范围（是否有适合流媒体的节点）、速度表现（是否支持4K流畅播放）、价格合理性。推荐选择有明确零日志政策的付费VPN服务，避免使用免费VPN。',
  },
  {
    id: 'faq-5',
    question: '为什么有些视频在海外看不了，有些在国内看不了？',
    answer: '这是由于版权的地域限制造成的。影视内容的版权通常按地区出售，平台只拥有在特定地区播放的权利。因此，Netflix等海外平台会检测IP地址，限制非授权地区的访问。同样，国内平台也会限制海外IP观看部分内容。',
  },
  {
    id: 'faq-6',
    question: '2025年看片网站会涨价吗？',
    answer: '从行业趋势来看，视频平台会员价格呈缓慢上涨趋势。2025年，各大平台可能会通过推出更高等级的会员（如AI增强画质、独家互动内容等）来实现变相涨价。建议关注各平台的年度大促（如双11、618），在促销期间购买年费会员最划算。',
  },
  {
    id: 'faq-7',
    question: '看片网站的4K画质需要什么网络条件？',
    answer: '流畅观看4K内容通常需要至少20-25Mbps的稳定带宽。Netflix由于编码效率高，15Mbps即可。如果是家庭多人同时使用网络，建议至少100Mbps的宽带。此外，还需要支持4K的显示设备和相应的会员等级。',
  },
  {
    id: 'faq-8',
    question: '可以在多个设备上同时使用一个会员账号吗？',
    answer: '大多数平台允许一个账号在2-5台设备上登录，但同时播放的设备数量有限制。例如爱奇艺黄金VIP允许2台设备同时观看，星钻VIP允许4台。Netflix根据套餐不同允许1-4个屏幕同时播放。具体规则请查看各平台会员协议。',
  },
];